export const audienceManifestQueryKeys = {
  all: ['audience-manifest'] as const,
  snapshot: () => [...audienceManifestQueryKeys.all, 'snapshot'] as const,
  recentPrompts: () =>
    [...audienceManifestQueryKeys.all, 'recent-prompts'] as const,
  properties: () => [...audienceManifestQueryKeys.all, 'properties'] as const,
  scvStats: () => [...audienceManifestQueryKeys.all, 'scv-stats'] as const,
  filterOptions: (propertyId: string, search: string) =>
    [
      ...audienceManifestQueryKeys.all,
      'filter-options',
      propertyId,
      search
    ] as const,
  unclassifiedTitles: (payload: { filters: unknown[]; session_id?: string | null; limit?: number }) =>
    [
      ...audienceManifestQueryKeys.all,
      'unclassified-titles',
      payload
    ] as const,
  audienceDetail: (audienceId: string) =>
    [...audienceManifestQueryKeys.all, 'audience', audienceId] as const,
  audiencePainPoints: (audienceId: string) =>
    [...audienceManifestQueryKeys.all, 'pain-points', audienceId] as const,
  audienceUnmatched: (audienceId: string) =>
    [...audienceManifestQueryKeys.all, 'unmatched', audienceId] as const,
  audienceList: () => [...audienceManifestQueryKeys.all, 'audience-list'] as const,
  audiencePreviewCount: (audienceId: string) =>
    [...audienceManifestQueryKeys.all, 'preview-count', audienceId] as const,
  preview: (
    audienceId: string | null,
    segmentSql: string | null,
    page: number,
    pageSize: number,
    sortColumn: string | null,
    sortDirection: string | null
  ) =>
    [
      ...audienceManifestQueryKeys.all,
      'preview',
      audienceId ?? '',
      segmentSql ?? '',
      page,
      pageSize,
      sortColumn ?? '',
      sortDirection ?? ''
    ] as const
};
